<template>
  <div class="form-section-element">
    <h4 class="form-section-title" v-if="section.title">{{ section.title }}</h4>
    <div class="form-section-info" v-show="section.subtitle">{{ section.subtitle }}</div>
  </div>
</template>

<script>
export default {
  name: 'FormSection',
  props: {
    section: Object,
    default () {
      return {
        title: '',
        subtitle: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormSection.vue?1949b8a1